<template>
  <a-dialog ref="dialog" size="small" name="remove_keywords" :loading="loading" @open="opened" @close="$reset">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      {{ $t('remove-keywords', {ids: ids.length} ) }}

    </div>
    <span slot="actions">
      <v-btn color="error" text @click="submit">
        {{ $tc('remove-keywords-submit', ids.length ) }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'RemoveKeywordsDialog',
  data () {
    return {
      loading: '',
      ids: []
    }
  },
  methods: {
    opened ({ ids }) {
      if (ids.length === 0) {
        this.$ui.warning(this.$t('select-keyword'))
        if (this.$refs.dialog) this.$refs.dialog.close()
      }

      this.ids = ids
    },
    async submit () {
      this.loading = this.$tc('loading', this.ids.length)

      try {
        await this.$api.post('monitors/remove', { ids: this.ids })
        this.$ui.success(this.$t('success'))
        this.$bus.emit('monitoring/require_refresh')
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"loading": "Removing keyword ... | Removing keywords ...",
		"remove-keywords": "Are you sure you want to delete {ids} keywords? This action is irreversible and the historical data will be deleted.",
		"remove-keywords-submit": "Remove 0 keyword | Remove {n} keyword | Remove {n} keywords",
		"select-keyword": "You must at least select a keyword to delete.",
		"success": "The keywords have been deleted successfully.",
		"title": "Delete Keywords"
	},
	"es": {
		"loading": "Eliminación de la palabra clave ... | Eliminación de las palabras clave ...",
		"remove-keywords": "¿Está seguro de que desea eliminar {ids} palabras clave? Esta acción es irreversible y se eliminarán los datos históricos.",
		"remove-keywords-submit": "Eliminar 0 palabra clave | Eliminar {n} palabra clave | Eliminar {n} palabras clave",
		"select-keyword": "Debe seleccionar al menos una palabra clave para eliminar.",
		"success": "Las palabras clave se han eliminado con éxito.",
		"title": "Eliminar palabras clave"
	},
	"fr": {
		"loading": "Suppression du mot clé ... | Suppression des mots clés ...",
		"remove-keywords": "Souhaitez-vous réellement supprimer {ids} mots clés ? Cette action est irréversible et les données d'historique seront supprimées.",
		"remove-keywords-submit": "Supprimer 0 mot clé | Supprimer {n} mot clé | Supprimer {n} mots clés",
		"select-keyword": "Vous devez au moins sélectionner un mot clé à supprimer.",
		"success": "Les mots clés ont été supprimés avec succès.",
		"title": "Supprimer des mots clés"
	},
	"it": {
		"loading": "Eliminazione parola chiave ... | Eliminazione parole chiave ...",
		"remove-keywords": "Sei sicuro di voler eliminare {ids} parole chiave? Questa azione è irreversibile e i dati storici verranno eliminati.",
		"remove-keywords-submit": "Rimuovi 0 parole chiave | Rimuovi {n} parola chiave | Rimuovi {n} parole chiave",
		"select-keyword": "Devi selezionare almeno una parola chiave da eliminare.",
		"success": "Le parole chiave sono state eliminate con successo.",
		"title": "Elimina parole chiave"
	},
	"pt": {
		"loading": "A remover palavra-chave ... | A remover palavras-chave ...",
		"remove-keywords": "Tem a certeza de que deseja eliminar {ids} palavras-chave? Esta ação é irreversível e os dados históricos serão eliminados.",
		"remove-keywords-submit": "Remover 0 palavra-chave | Remover {n} palavra-chave | Remover {n} palavras-chave",
		"select-keyword": "Deve selecionar pelo menos uma palavra-chave para eliminar.",
		"success": "As palavras-chave foram eliminadas com sucesso.",
		"title": "Eliminar palavras-chave"
	},
	"pl": {
		"loading": "Usuwanie słowa kluczowego ... | Usuwanie słów kluczowych ...",
		"remove-keywords": "Czy na pewno chcesz usunąć {ids} słów kluczowych? Ta akcja jest nieodwracalna i dane historyczne zostaną usunięte.",
		"remove-keywords-submit": "Usuń 0 słów kluczowych | Usuń {n} słowo kluczowe | Usuń {n} słów kluczowych",
		"select-keyword": "Musisz wybrać co najmniej jedno słowo kluczowe do usunięcia.",
		"success": "Słowa kluczowe zostały pomyślnie usunięte.",
		"title": "Usuń słowa kluczowe"
	}
}
</i18n>
